import React, { useRef } from 'react';

/**
 * Composant SubNavbar réutilisable pour maintenir la cohérence des bordures et espacements
 * @param {React.ReactNode} children - Contenu à afficher dans la subnavbar
 * @param {boolean} sticky - Si true, la subnavbar reste fixe en haut lors du scroll
 * @param {string} className - Classes CSS additionnelles
 */
const SubNavbar = ({ children, sticky = true, className = '' }) => {
  const scrollContainerRef = useRef(null);

  const handleWheel = (e) => {
    const container = scrollContainerRef.current;
    if (container && e.deltaY !== 0) {
      // Vérifier si le contenu dépasse la largeur visible
      const hasHorizontalScroll = container.scrollWidth > container.clientWidth;
      if (hasHorizontalScroll) {
        e.preventDefault();
        container.scrollLeft += e.deltaY;
      }
    }
  };

  return (
    <div
      className={`w-full bg-white border-b border-gray-100 ${sticky ? 'tab:sticky tab:top-0 z-20' : ''} ${className}`}
    >
      <div 
        ref={scrollContainerRef}
        className="px-3 tab:px-4 lg:px-8 h-[72px] flex items-center overflow-x-auto overflow-y-hidden thin-scrollbar" 
        style={{ WebkitOverflowScrolling: 'touch' }}
        onWheel={handleWheel}
      >
        <div className="flex items-center gap-3 whitespace-nowrap min-w-max w-full justify-between">
          {children}
        </div>
      </div>
    </div>
  );
};

export default SubNavbar;

